/**
 * Sequential lens - Standard 1..N behavior
 * Projects lines sequentially based on position
 */

import type { CascadeLens, Block } from '../types';

export const sequentialLens: CascadeLens = {
  id: 'sequential',
  name: 'Sequential',
  project: (position: number, cascade: Block): string[] => {
    const { lines } = cascade;
    if (lines.length === 0) return [];

    // Convert 0-1 position to line index
    const targetIndex = Math.floor(position * lines.length);
    const clampedIndex = Math.max(0, Math.min(targetIndex, lines.length - 1));

    // Return lines from start up to the current position
    return lines.slice(0, clampedIndex + 1);
  },
  sliderConfig: {
    steps: 100, // Fine-grained control
    labels: ['Start', 'End'],
  },
};